import { render, staticRenderFns } from "./ModalDispute.vue?vue&type=template&id=1d980972&scoped=true"
import script from "./ModalDispute.vue?vue&type=script&lang=js"
export * from "./ModalDispute.vue?vue&type=script&lang=js"
import style0 from "./ModalDispute.vue?vue&type=style&index=0&id=1d980972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d980972",
  null
  
)

export default component.exports